<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import Page from '~/enums/page'

const router = useRouter()
</script>

<template>
  <div class="relative z-50 min-h-[120vh] w-full overflow-hidden rounded-3xl !bg-main-blue md:min-h-screen">
    <div
      class="absolute bottom-0 right-0 z-10 hidden size-full bg-contain bg-right-bottom bg-no-repeat md:block"
      :style="`background-image: url(background-image: url(https://cdn.itab.pro/partner/pattern.png))`"
    />

    <div
      class="
        absolute bottom-0 right-0 z-20 size-full !max-h-[65vh] bg-cover bg-center bg-no-repeat
        md:!max-h-full md:w-2/3 md:bg-contain md:bg-right-bottom
      "
      :style="`background-image: url(https://cdn.itab.pro/partner/expert-girl.png)`"
    />

    <div
      class="
        relative z-50 flex h-screen w-full flex-wrap content-start px-3 py-5 md:content-between
        md:items-start md:p-6 lg:p-10
      "
    >
      <div class="flex w-full justify-between px-10 py-5">
        <NormalLogo />

        <a
          class="flex h-min items-center"
          href="#"
          @click.prevent="router.push({ path: Page.Main })"
        >
          <SvgIcon class="!size-6 !text-white 2xl:!size-9" name="outlined/close" />
        </a>
      </div>

      <div class="mt-20 max-w-full md:mt-0 md:max-w-[509px]">
        <AppTipe class="mb-4 md:mb-3" title="Неграниченный заработок с&nbsp;платформой" />

        <BaseTitle title="Станьте партнёром iTAB и&nbsp;монетизируйте свою экспертность" />

        <BasicButton
          class="mt-6 !h-[56px] !px-8 !duration-300 hover:!bg-main-blue hover:!text-white md:mt-7 md:!w-min"
          color="white"
          title="Cтать&nbsp;партнером"
          @click="router.push({ path: Page.PartnerSignup })"
        />
      </div>
    </div>
  </div>
</template>
